export const populationData = [
    {
        name: 'Lazio',
        value: 26.7,
        pop: 43425, // Approx derived from 26.7% of 162k
    },
    {
        name: 'Lombardia',
        value: 16.0,
        pop: 26022,
    },
    {
        name: 'Veneto',
        value: 12.4,
        pop: 20167,
    },
    {
        name: 'Emilia-Romagna',
        value: 8.5, // Estimation based on distribution
        pop: 13824,
    },
    {
        name: 'Campania',
        value: 6.6,
        pop: 10734,
    },
    {
        name: 'Sicilia',
        value: 6.0,
        pop: 9758,
    },
    {
        name: 'Toscana',
        value: 5.5, // Estimation
        pop: 8945,
    },
    {
        name: 'Altre',
        value: 18.3,
        pop: 29766,
    },
];

export const genderData = [
    { name: 'Uomini', value: 72, fill: '#0066cc' },
    { name: 'Donne', value: 28, fill: '#ff6b6b' },
];

export const employmentData = [
    { name: 'Ristorazione/Alberghi', value: 30.4 },
    { name: 'Industria', value: 25.6 },
    { name: 'Commercio', value: 23.0 },
    { name: 'Agricoltura', value: 8.5 },
    { name: 'Altro', value: 12.5 },
];

export const growthData = [
    { year: '2019', pop: 139953 },
    { year: '2020', pop: 147872 },
    { year: '2021', pop: 150692 },
    { year: '2022', pop: 158000 }, // Approx
    { year: '2023', pop: 162641 },
];
